import api from "./api";

export type CompanyBackupImportMode = "CREATE" | "REPLACE";

export interface CompanyBackupImportResult {
  companyId: number;
  mode: CompanyBackupImportMode;
  insertedCounts: Record<string, number>;
  safetySnapshotFile?: string;
}

/** Exporta os dados da empresa do usuário logado (manager/owner). */
export async function exportCompanyBackup(): Promise<Blob> {
  const res = await api.get("/company-backup/export", { responseType: "blob" });
  return res.data;
}

/** Exporta os dados de uma empresa escolhida pelo admin. */
export async function exportCompanyBackupAsAdmin(companyId: number): Promise<Blob> {
  const res = await api.get(`/company-backup/${companyId}/export`, {
    responseType: "blob",
  });
  return res.data;
}

/** Reimporta o backup JSON de uma empresa. Só ADMIN. */
export async function importCompanyBackup(
  companyId: number,
  file: File,
  mode: CompanyBackupImportMode,
  confirmationPhrase?: string
): Promise<CompanyBackupImportResult> {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("mode", mode);
  if (confirmationPhrase) {
    formData.append("confirmation_phrase", confirmationPhrase);
  }

  const { data } = await api.post<CompanyBackupImportResult>(
    `/company-backup/${companyId}/import`,
    formData,
    { headers: { "Content-Type": "multipart/form-data" } }
  );
  return data;
}
